<template>
  <div v-if="init" class="products">
    <h1>Products</h1>

    <div class="controls">
      <div class="search">
        <input type="text" placeholder="Search" v-model="search" />
      </div>
      <div class="meta">
        <span
          >Showing: {{ getProductsBySearch(search).length }} /
          {{ productCount }}
        </span>
      </div>
    </div>

    <div class="admin-table products-table">
      <div class="table-header">
        <span class="prodno label">ID</span>
        <span class="name label">Name</span>
        <span class="description label">Description</span>
        <span class="unit label">Unit</span>
        <span class="stock label">Stock</span>
        <span class="group label">Group</span>
        <span class="category label">Category</span>
        <span class="always-in-stock label">Always in stock?</span>
      </div>
      <div v-for="prod in getProductsBySearch(search)" :key="prod.id">
        <span class="prodno">{{ prod.vismaId }} {{ prod.firebaseId }}</span>
        <span class="name">{{ prod.name }}</span>
        <span class="description">{{ prod.description }}</span>
        <span class="unit">{{ prod.unit }}</span>
        <span class="stock">{{ prod.stock }}</span>
        <span class="group">{{ prod.group }}</span>
        <span class="category">{{ prod.category }}</span>
        <span class="always-in-stock">
          <button
            class="always-in-stock-button"
            :class="{
              active: checkToggleStatus(prod.firebaseId, prod.alwaysInStock),
            }"
            @click="
              toggleAlwaysInStock(
                prod.firebaseId,
                prod.alwaysInStock,
                prod.name
              )
            "
          ></button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { db } from "@/main.js";

export default {
  data() {
    return {
      createEmail: "",
      loading: false,
      message: "",
      search: "",
    };
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState({
      productList: (state) => state.products.productList,
      init: (state) => state.settings.init,
      localAlwaysInStock: (state) => state.products.localAlwaysInStock,
    }),
    ...mapGetters("products", ["getProductsBySearch", "productCount"]),
  },
  methods: {
    checkToggleStatus: function (firebaseId, alwaysInStock) {
      return this.localAlwaysInStock[firebaseId] !== undefined
        ? this.localAlwaysInStock[firebaseId]
        : alwaysInStock;
    },
    toggleAlwaysInStock: function (firebaseId, alwaysInStock, name) {
      let value;
      if (this.localAlwaysInStock[firebaseId] === undefined) {
        this.$store.commit("products/updateLocalAlwaysInStock", {
          key: firebaseId,
          value: !alwaysInStock,
        });
        value = !alwaysInStock;
      } else {
        value = !this.localAlwaysInStock[firebaseId];
        this.$store.commit("products/updateLocalAlwaysInStock", {
          key: firebaseId,
          value: !this.localAlwaysInStock[firebaseId],
        });
      }

      console.log("Setting: " + value);

      db.collection("products")
        .doc(firebaseId)
        .update({
          alwaysInStock: value,
          name: name + " ", // This will toggle sync.
        });
    },
  },
};
</script>
